<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 13 16"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M13.209 7.266H.708l3.947-4.384c.194-.218.175-.553-.042-.747-.218-.195-.553-.176-.748.042L-.87 7.439l-.016.021-.024.03-.015.023-.021.034-.016.032v.163c0 .013-.037.023-.037.05 0 .026 0 0 0 0v.2l.016.031.02.035.017.023.023.03.016.02 4.736 5.263c.195.218.53.237.748.042.218-.195.237-.53.042-.747l-3.91-4.37h12.5c.292 0 .527-.237.527-.527 0-.29-.235-.526-.526-.526z"
        transform="translate(-1382 -710) matrix(0 -1 -1 0 1396.153 724.153)"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-download",
  components: {},
})
export class IconDownload extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconDownload;
</script>
